import React, { useState, useEffect, createContext } from "react";
import { Typography, Container, Box, useMediaQuery, useTheme 
} from "@mui/material";
import { useParams, Outlet } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { List, ListItem, ListItemText, ListItemButton, ListItemIcon } from "@mui/material";
import ArticleIcon from '@mui/icons-material/Article';
import PeopleIcon from '@mui/icons-material/People';
import PeopleAvatarGroup from '../../components/PeopleAvatarGroup';
import EventWithNameTest from "../../components/EventWithNameTest";
import EventDetailsCompact from "../../components/EventDetailsCompact";
import ResponsiveJoinedAppBar from "../../components/AppBarLoggedIn";
import ChatIcon from '@mui/icons-material/Chat';
import Footer from "../../components/Footer";

// Create Theme Context
const ThemeContext = createContext();

const EventJoined = () => {
    
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.down("lg"));
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { eventCode } = useParams();  // Capture the eventCode from the URL
    const [eventDetails, setEventDetails] = useState(null);
    const [eventDocId, setEventDocId] = useState(null);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        if (eventCode) {
          fetchEvent(eventCode);
        }
      }, [eventCode]);
      
      const fetchEvent = async (code) => {
        try {
          setError('');
          setEventDetails(null);
          setEventDocId(null);
    
          // Find the event document by eventCode
          const eventsRef = collection(db, 'events');
          const eventQuery = query(eventsRef, where('eventCode', '==', code));
          const eventSnapshot = await getDocs(eventQuery);
    
          if (!eventSnapshot.empty) {
            // Assume the first matching event document
            const eventDoc = eventSnapshot.docs[0];
            const eventData = eventDoc.data();

            // Setting the page title 
            // {document.title = "nKuvu - " + eventData.eventName}
    
            setEventDocId(eventDoc.id);  // Store document ID for post retrieval
            setEventDetails({
              eventImage: eventData.eventImageURL,
              eventName: eventData.eventName,
              eventCode: eventData.eventCode,
              eventOwnerName: eventData.eventOwnerName,
              eventCity: eventData.eventCity,
              eventLocation: eventData.eventLocation,
              eventStartDate: eventData.eventStartDate,
            });
          } else {
            setError('No event found with that event code.');
          }
        } catch (err) {
          console.error("Error fetching event:", err);
          setError('Failed to retrieve event data.');
        }
      };
      
  return ( 
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", bgcolor: "grey.200",}}>      
      <ResponsiveJoinedAppBar/>
      {/* Main Content */}
      <Container component="main" sx={{ flex: 1, mt: 2, display: "flex", justifyContent: "center" }}>
        <Box sx={{display: "grid",gridTemplateColumns: isMobile? "1fr" : isMedium ? "30% 70%": "20% 80%",
              gap: "20px", maxWidth: "1200px", width: "100%", }}>
          {/* Left Sidebar */}
          <Box > 
            
            <Box flexGrow={1} padding={2} marginBottom={3} sx={{ alignItems: "center", bgcolor: 'background.paper', borderRadius:3,}}>
              <Typography variant="subtitle1" color="text.primary"> Hi Annonimous, good to see you!</Typography>
            </Box>

            {/* <Box flexGrow={1} padding={1} marginBottom={3} sx={{ alignItems: "center", bgcolor: 'background.paper', borderRadius:3,}}>
              <List>         
                <ListItem disablePadding button onClick={() => navigate(`/join/${eventCode}`)}>
                  <ListItemButton>
                    <ListItemIcon>
                      <ChatIcon />
                    </ListItemIcon>
                    <ListItemText  color="text.primary" ><Typography variant="subtitle1" color="textPrimary"> Posts</Typography></ListItemText>
                  </ListItemButton>
                </ListItem>                      
                <ListItem disablePadding button onClick={() => navigate(`/join/${eventCode}/people`)}>
                <ListItemButton>
                  <ListItemIcon>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText  color="text.primary" ><Typography variant="subtitle1" color="textPrimary"> People</Typography></ListItemText>
                </ListItemButton>
              </ListItem>
                <ListItem disablePadding button onClick={() => navigate(`/join/${eventCode}/resources`)}>
                <ListItemButton>
                  <ListItemIcon>
                    <ArticleIcon />
                  </ListItemIcon>
                  <ListItemText ><Typography variant="subtitle1" color="textPrimary"> Resources</Typography></ListItemText> 
                </ListItemButton>
              </ListItem>
                <ListItem disablePadding button onClick={() => navigate(`/join/${eventCode}/resources`)}>
                <ListItemButton>
                  <ListItemIcon>
                    <ArticleIcon />
                  </ListItemIcon>
                  <ListItemText ><Typography variant="subtitle1" color="textPrimary"> Schedule</Typography></ListItemText> 
                </ListItemButton>
              </ListItem>
                <ListItem disablePadding button onClick={() => navigate(`/join/${eventCode}/resources`)}>
                <ListItemButton>
                  <ListItemIcon>
                    <ArticleIcon />
                  </ListItemIcon>
                  <ListItemText ><Typography variant="subtitle1" color="textPrimary"> Map</Typography></ListItemText> 
                </ListItemButton>
              </ListItem>
                <ListItem disablePadding button onClick={() => navigate(`/join/${eventCode}/resources`)}>
                <ListItemButton>
                  <ListItemIcon>
                    <ArticleIcon />
                  </ListItemIcon>
                  <ListItemText ><Typography variant="subtitle1" color="textPrimary"> Sponsors</Typography></ListItemText> 
                </ListItemButton>
              </ListItem>
              </List>
            </Box>         */}
                        
            {/* <EventDetailsCompact eventDetails={eventDetails}/> */}

          </Box>

          {/* Main Content */}
          <Box sx={{ minHeight: "400px" }}>

            {/* <EventHero eventDetails={eventDetails} />    */}

            <Outlet />
                
            <PeopleAvatarGroup eventDocId={eventDocId}/>
            {eventDocId && <EventWithNameTest eventDocId={eventDocId} />}

          </Box>
          
        </Box>
      </Container>

      <Footer />

      {/* Footer */}
      {/* <Box component="footer" sx={{ bgcolor: 'background.paper', textAlign: "center", py: 2, mt: "auto" }}>
        <Typography variant="body2" color="text.primary">© 2025 nKuvu</Typography>
      </Box> */}
    </Box>
  );
};

// Theme Provider Wrapper
const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
    },
  });

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <ThemeProvider theme={theme}>
        <EventJoined />
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default App;
